import { render, staticRenderFns } from "./BinanceTradesSocket.vue?vue&type=template&id=57492a40&"
import script from "./BinanceTradesSocket.vue?vue&type=script&lang=js&"
export * from "./BinanceTradesSocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports